module.exports = __webpack_public_path__ + "img/logoH.49a56834.png";